import { render, staticRenderFns } from "./pop-layout.vue?vue&type=template&id=76b44bae"
import script from "./pop-layout.vue?vue&type=script&lang=js"
export * from "./pop-layout.vue?vue&type=script&lang=js"
import style0 from "./pop-layout.vue?vue&type=style&index=0&id=76b44bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports